/**
 * The public synthetic "En plan som håller" example report (redesign,
 * 2026-10-09, "Ledning" preset, EXEMPEL band on every page; v12 2026-10-24:
 * the Caire proposal passes the public metric bar, 63 % → 74 % brukartid). Dated file names
 * bust caches; change REPORT_EXAMPLE_DATE when the assets are re-rendered.
 */
export const REPORT_EXAMPLE_DATE = "20261024-v12";
type Locale = "sv" | "en";
const dir = "/images/analysis-report";

export const reportExamplePdf = (locale: Locale) =>
  `${dir}/example-${locale}-${REPORT_EXAMPLE_DATE}.pdf`;

export type ReportImage = {
  base: string;
  widths: number[];
  width: number;
  height: number;
  /** Full-resolution WebP for "open the image" links. */
  full: string;
};

/** Page 1 (Overview), page 2 (Your plan), and page 3 (What needs attention). */
export function reportExampleImage(
  page: "cover" | "summary" | "plan-check",
  locale: Locale,
): ReportImage {
  const base = `${dir}/${page}-${locale}-${REPORT_EXAMPLE_DATE}`;
  if (page === "plan-check")
    return {
      base,
      widths: [640, 960, 1336],
      width: 1336,
      height: 1890,
      full: `${base}-1336.webp`,
    };
  return {
    base,
    widths: [480, 720, 1080],
    width: 1587,
    height: 2246,
    full: `${base}-1587.webp`,
  };
}
